<header class="header">
  <div class="header-left">
    <div class="brand">
      <img src="/castor_logo_head.png" alt="Castor" class="brand-logo" />
      <span class="brand-customer">{{ customerName() }}</span>
    </div>
    <div class="brand-spacer"></div>
    <nav class="tabs">
      <a
        *ngIf="adminMode()"
        routerLink="/cruds"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
        class="manage-cruds-button"
      >
        {{ 'nav.myForms' | translate }}
      </a>
      <a
        *ngIf="adminMode()"
        routerLink="/marketplace"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
        class="manage-cruds-button"
      >
        {{ 'nav.myMarketplace' | translate }}
      </a>
      <ng-container *ngIf="!adminMode()">
        <a
          *ngFor="let crud of formsForMenu()"
          [routerLink]="['/run', crud.crudId]"
          routerLinkActive="active"
          class="manage-cruds-button"
        >
          {{ crud.name }}
        </a>
      </ng-container>
    </nav>
  </div>
  <div class="header-actions">
    <span class="poc-label">POC V0.1</span>
    <div class="lang-toggle" aria-label="Language selector">
      <button
        type="button"
        class="lang-pill"
        [class.lang-pill-active]="i18n.locale === 'pt-BR'"
        (click)="setLanguage('pt')"
      >
        PT
      </button>
      <span class="lang-separator">|</span>
      <button
        type="button"
        class="lang-pill"
        [class.lang-pill-active]="i18n.locale === 'en'"
        (click)="setLanguage('en')"
      >
        EN
      </button>
    </div>
    <button class="btn theme-toggle" type="button" (click)="toggleTheme()" [title]="themeService.theme() === 'light' ? 'Dark mode' : 'Light mode'">
      {{ themeService.theme() === 'light' ? 'Dark mode' : 'Light mode' }}
    </button>
    <button class="btn logout" type="button" (click)="logout()">Logout</button>
  </div>
</header>
<main class="main">
  <div class="main-inner">
    <router-outlet />
  </div>
</main>
